import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { socket } from 'api';
import { playSound, stopSound } from 'store/actions/sounds';
import { dropCall } from 'store/actions/calls';
import { Content, ButtonBlock, CallBlock, CallIcon, CallBadge, CallWaves } from './RackCall.styled';

export const RackCall = ({ info }) => {
  // console.log('🚀 ~ RackCall ~ info:', info);
  const { status } = info;

  const dispatch = useDispatch();

  // start/stop sound
  useEffect(() => {
    if (status === 'wait' /*&& !isActiveCallExist && !isSoundPlay*/) {
      // console.log('🚀 ~ play soynd:');
      dispatch(playSound('call'));
    } else {
      // if (isActiveCallExist || status !== 'wait') {
      dispatch(stopSound('call'));
      // }
    }

    return () => {
      // console.log('rackCall effect exit')
      // dispatch(stopSound('call'));
    };
  }, [status /*, isActiveCallExist, isSoundPlay*/]);

  // render
  return (
    <Content>
      <CallBadge>
        {status === 'active' && <CallWaves />}
        <CallIcon status={status} src="/images/call.svg" />
      </CallBadge>
    </Content>
  );
};

/**
 * кнопки «Ответить / Отклонить» — рендерятся внутри Tip (над ним по центру), видны при наведении на RackWrapper
 */
export const RackCallActions = ({ info }) => {
  const { status, source_inner_id } = info;
  const isActiveCallExist = useSelector((store) => store.widgets.activeWidgets.indexOf('activeCall') >= 0);
  const dispatch = useDispatch();

  /**
   * answer
   */
  const makeAnswerRequest = () => {
    // console.log("isActiveCallExist", isActiveCallExist);
    if (isActiveCallExist) {
      return;
    }
    dispatch(stopSound('call'));
    socket.call('call_answer', info);
    window.addActiveCall(source_inner_id);
  };

  /**
   * cancel call
   */
  const cancelCall = () => {
    if (isActiveCallExist) {
      socket.call('call_end', {
        id: info.id,
        target: source_inner_id,
      });
    } else {
      socket.call('call_reject', {
        id: info.id,
        source: source_inner_id,
      });
    }
    dispatch(stopSound('call'));
    dispatch(dropCall(source_inner_id));
  };

  if (status !== 'wait') {
    return null;
  }

  return (
    <CallBlock>
      <ButtonBlock onClick={makeAnswerRequest}>
        <img src="/images/call-answer.svg" alt="" />
        <span>Ответить</span>
      </ButtonBlock>
      <ButtonBlock onClick={cancelCall}>
        <img src="/images/call-cancel.svg" alt="" />
        <span>Отклонить</span>
      </ButtonBlock>
    </CallBlock>
  );
};
